import { fetchList } from "@/api/setting/area";
export default {
    namespaced: true,

    state() {
        return {
            rawAreaList: [],
            areaList: [],
        }
    },

    getters: {

    },

    mutations: {
        setRawAreaList(state, payload) {
            state.rawAreaList = payload
        },
        setAreaList(state, payload) {
            state.areaList = payload
        },
    },

    actions: {
        getAreaList({ commit }) {
            return new Promise((resolve) => {
                fetchList().then(res => {
                    if (Array.isArray(res)) {
                        commit('setRawAreaList', Object.freeze(res))
                        commit('setAreaList', Object.freeze(filterList(res, null)))
                        resolve();
                    }
                })
            })
        }
    }

}

function filterList(list, pid) {
    const tree = [];
    list.forEach((item) => {
        if (item.pid === pid) {
            let children = filterList(list, item.id);
            const node = {
                ...item,
                key: item.id,
                value: item.id,
                label: item.areaName,
            };
            if (children && children.length > 0) {
                node.children = children;
            } else {
                delete node.children;
            }
            tree.push(node);
        }
    });
    return tree;
}